export const PD_RANGE_BY_FRAME_SIZE:Record<string, {min: number,  max: number}> = {
  XS: {
    min: 33,
    max: 80
  },
  S: {
    min: 33,
    max: 80
  },
  M: {
    min: 33,
    max: 80
  },
  L: {
    min: 33,
    max: 80
  }
};

export const PD_RANGE_BY_FRAME_SIZE_MONO:Record<string, {min: number,  max: number}> = {
  XS: {
    min: 16.5,
    max: 40
  },
  S: {
    min: 16.5,
    max: 40
  },
  M: {
    min: 16.5,
    max: 40
  },
  L: {
    min: 16.5,
    max: 40
  }
}